import { PUSHER_APP_KEY } from '@pukka/common/constants';
import Pusher, { Channel } from 'pusher-js';

const pusher = new Pusher(PUSHER_APP_KEY, {
  cluster: 'ap1',
});

export { pusher, type Channel };
